import { money } from '../cards';
/** How each SPR bucket reads (schema/buckets.ts SprBucket). Factual depth label, no strategy verdict. */
const SPR_PHRASE = {
    under1: 'commitment territory',
    '1to3': 'shallow',
    '3to6': 'medium',
    '6to13': 'deep',
    over13: 'very deep',
};
/** How each equity bucket reads, with tone (schema/buckets.ts EquityBucket, §8.1 boundaries). */
const EQUITY_PHRASE = {
    weak: { label: 'weak', tone: 'bad' },
    behind: { label: 'behind', tone: 'caution' },
    flip: { label: 'a coin-flip', tone: 'neutral' },
    ahead: { label: 'ahead', tone: 'good' },
    dominant: { label: 'dominant', tone: 'good' },
};
/**
 * The numeric picture of the decision: what it costs to continue (pot-odds + required equity), the
 * stack-to-pot depth, and where hero's equity sits. Price line appears only when there is something to
 * call (toCall > 0); the pot-size line covers the checked-to-hero case. Pure over EngineFacts.math.
 */
export function price(facts) {
    const lines = [];
    const m = facts.math;
    if (m.toCall > 0 && m.potOdds && m.potOdds !== '-' && m.requiredEquityPct !== undefined) {
        lines.push({
            kind: 'price',
            text: `${money(m.toCall)} to call into ${money(m.pot)} at ${m.potOdds}, you need ${Math.round(m.requiredEquityPct)}% to continue.`,
            tone: 'neutral',
        });
    }
    else {
        lines.push({ kind: 'price', text: `Pot is ${money(m.pot)}, no bet to call.`, tone: 'neutral' });
    }
    // SPR / stack depth.
    lines.push({
        kind: 'spr',
        text: `Stack-to-pot ${m.spr.toFixed(1)}, ${SPR_PHRASE[m.sprBucket]}.`,
        tone: 'neutral',
    });
    // Hero equity vs the villain's continuing range.
    const eq = EQUITY_PHRASE[facts.hero.equityBucket];
    const pct = Math.round(facts.hero.equity.equity * 100);
    lines.push({
        kind: 'equity',
        text: `Your equity is ${eq.label}, about ${pct}% against his continuing range.`,
        tone: eq.tone,
    });
    return lines;
}
//# sourceMappingURL=price.js.map